import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CallState {
  activeCall: any | null;
  connected: boolean;
  rejectedMessage: string;
  callDisconnectedData: any | null;
  showReferencePopup: boolean;
  showAddToZyvo: boolean;
  showLeadMgmtOutcomeModal: boolean;
  redialRequested: boolean;
  isAutoCall: boolean;
  autoCallStopped: boolean;
  isLeadsMode: boolean;
  selectedCompany: {
    companyId: string;
    companyName: string;
    companyType: string;
  };
  pendingNavigationPath: string | null;
  pendingNote?: string | null;
}

const initialState: CallState = {
  activeCall: null,
  connected: false,
  rejectedMessage: "",
  callDisconnectedData: null,
  showReferencePopup: false,
  showAddToZyvo: false,
  showLeadMgmtOutcomeModal: false,
  redialRequested: false,
  isAutoCall: false,
  autoCallStopped: false,
  isLeadsMode: false,
  selectedCompany: { companyId: "", companyName: "", companyType: "" },
  pendingNavigationPath: null,
  pendingNote: "",
};

const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    setPendingNavigationPath: (state, action) => {
      state.pendingNavigationPath = action.payload;
    },
    setSelectedCompany: (
      s,
      a: PayloadAction<{
        companyId: string;
        companyName: string;
        companyType: string;
      }>,
    ) => {
      s.selectedCompany = a.payload;
    },
    setActiveCall: (s, a: PayloadAction<any>) => {
      s.activeCall = a.payload;
    },
    setConnected: (s, a: PayloadAction<boolean>) => {
      s.connected = a.payload;
    },
    setRejectedMessage: (s, a: PayloadAction<string>) => {
      s.rejectedMessage = a.payload;
    },
    setCallDisconnectedData: (s, a: PayloadAction<any>) => {
      s.callDisconnectedData = a.payload;
    },
    setShowReferencePopup: (s, a: PayloadAction<boolean>) => {
      s.showReferencePopup = a.payload;
    },
    setShowAddToZyvo: (s, a: PayloadAction<boolean>) => {
      s.showAddToZyvo = a.payload;
    },
    setShowLeadMgmtOutcomeModal: (s, a: PayloadAction<boolean>) => {
      s.showLeadMgmtOutcomeModal = a.payload;
    },
    setIsAutoCall: (s, a: PayloadAction<boolean>) => {
      s.isAutoCall = a.payload;
    },
    setAutoCallStopped: (s, a: PayloadAction<boolean>) => {
      s.autoCallStopped = a.payload;
    },
    setIsLeadsMode: (s, a: PayloadAction<boolean>) => {
      s.isLeadsMode = a.payload;
    },
    setPendingNote: (s, a: PayloadAction<string>) => {
      s.pendingNote = a.payload;
    },
    setRedialRequested: (s, a: PayloadAction<boolean>) => {
      s.redialRequested = a.payload;
    },
    resetCallState: () => initialState,
  },
});

export const callActions = callSlice.actions;
export default callSlice.reducer;

export type { CallState };
